import * as React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/auth.js';
import AppConfig from '../services/app-config.js';

import apiClient, { shouldRedirectToLogin } from '../services/api-client';

export default function Home(props) {
  const [navigateTo, setNavigateTo] = React.useState(null);
  const nextUrl = new URLSearchParams(location.search).get('next');

    
  React.useEffect(() => {
    const role = AuthService.getCurrentUserRole();
    const pendingTourStage = typeof window !== 'undefined' ? window.sessionStorage.getItem('mgo_admin_tour_stage_v1') : null;
    if (nextUrl !== null) {
      setNavigateTo(nextUrl);
      return;
    } else {
    switch (role) {
      case 'habitante':
        setNavigateTo('/residenthub?event=app_opened');
        break;
      case 'receptor':
        setNavigateTo('/recepcion');
        break;
      case 'admin':
        setNavigateTo(pendingTourStage && pendingTourStage !== 'completed' ? '/servicios' : '/adminhub');
        break;
      case 'superuser':
        setNavigateTo(pendingTourStage && pendingTourStage !== 'completed' ? '/servicios' : '/adminhub');
        break;
      default:
        setNavigateTo('/login');
    }}

    if (AuthService.isLogged()) {
      apiClient.get('users/configs', {}, { action: 'fetch_user_configs' })
      .then((response) => {
          // AppConfig.parseResponse is handled by apiClient
      })
      .catch(error => {
        console.error(error);
        if (shouldRedirectToLogin(error)) {
          setNavigateTo('/login');
        }
      })  
    } else {
      setNavigateTo('/login');
    }
          
    
  }, []);

  if (navigateTo) {
    return <Navigate to={navigateTo} />
  }

  // default render
  return null;
}